module.exports = __webpack_public_path__ + "img/btn_bnr_arr_prev.ce0bb515.svg";